"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _WidgetComponentRenderer = _interopRequireWildcard(require("./WidgetComponentRenderer"));

var _ReasoningTrace = _interopRequireWildcard(require("./ReasoningTrace"));

var _FollowUpPills = _interopRequireDefault(require("./FollowUpPills"));

var _TextComponent = _interopRequireWildcard(require("./TextComponent"));

var _Feedback = require("@insided/shared/modules/HubAI/Feedback");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// Dislike reasons offered after a 👎, mirroring AI Answers' option set but
// worded for a conversational agent answer.
var FEEDBACK_OPTIONS = ['Inaccurate content', 'Incomplete answer', 'Not relevant', 'Complex to understand', 'Query not answered'];

function isTextComponent(c) {
  return c.type === 'text';
}
/**
 * Combines the inline `forethought-agent__related-articles` UL/OL fragments
 * produced by `renderAndSplitTextComponent` (one fragment per text component)
 * into a single `<ul>`. Without this, each fragment renders as its own
 * `__text--sources` div with its own list, which looks like multiple
 * unrelated "Sources" sections in the rail.
 *
 * Dedupes by href — both raw and URL-decoded — so the same article doesn't
 * appear twice when the agent emits the URL once with `%28` / `%29` encoding
 * and once with literal parentheses.
 *
 * Returns an empty string when there's nothing to render so the caller can
 * gate the wrapper `<div>` on truthiness.
 */


function mergeArticleListFragments(fragments) {
  if (fragments.length === 0) return '';
  if (typeof DOMParser === 'undefined') return fragments.join('');
  var seenKeys = new Set();
  var mergedItemHtml = [];
  fragments.forEach(function (fragment) {
    var wrapper = new DOMParser().parseFromString("<div>".concat(fragment, "</div>"), 'text/html').body.firstChild;
    if (!wrapper) return;
    wrapper.querySelectorAll('.forethought-agent__related-articles > li').forEach(function (li) {
      var _anchor$getAttribute;

      var anchor = li.querySelector('a');
      var rawHref = (_anchor$getAttribute = anchor === null || anchor === void 0 ? void 0 : anchor.getAttribute('href')) !== null && _anchor$getAttribute !== void 0 ? _anchor$getAttribute : '';
      var normalized = rawHref;

      try {
        normalized = decodeURIComponent(rawHref);
      } catch (_unused) {// Malformed escape — fall back to the raw href so we still dedupe
        // exact-string duplicates.
      }

      var key = normalized || rawHref || li.textContent || '';
      if (seenKeys.has(key)) return;
      seenKeys.add(key);
      mergedItemHtml.push(li.outerHTML);
    });
  });
  if (mergedItemHtml.length === 0) return '';
  return "<ul class=\"forethought-agent__related-articles\">".concat(mergedItemHtml.join(''), "</ul>");
}

var AgentMessage = function AgentMessage(_ref) {
  var turn = _ref.turn,
      isLastAgentTurn = _ref.isLastAgentTurn,
      isFirstAgentTurn = _ref.isFirstAgentTurn,
      disabled = _ref.disabled,
      userQuery = _ref.userQuery,
      onButtonSelect = _ref.onButtonSelect,
      onFormSubmit = _ref.onFormSubmit,
      onFollowUpSelect = _ref.onFollowUpSelect,
      onSourceClick = _ref.onSourceClick,
      onFeedbackVote = _ref.onFeedbackVote;
  var articles = (0, _ReasoningTrace.extractArticlesFromComponents)(turn.components); // Two surfaces route to the right rail:
  //  1. Standalone `article` widget components (rich source cards).
  //  2. The "Related Articles:" UL embedded inside `text` component markdown,
  //     which `tagLinkListSections` flags with `.forethought-agent__related-articles`.

  var articleComponents = turn.components.filter(function (c) {
    return c.type === 'article';
  }); // Pre-render text components so the related-articles UL can be peeled off
  // before paint. Keyed by component index so the left/right halves stay
  // paired with the original component position.

  var textHtmlByIndex = new Map();
  turn.components.forEach(function (component, index) {
    if (isTextComponent(component)) {
      textHtmlByIndex.set(index, (0, _TextComponent.renderAndSplitTextComponent)(component));
    }
  });
  var inlineArticleHtmlFragments = [];
  textHtmlByIndex.forEach(function (entry) {
    if (entry.articlesHtml) inlineArticleHtmlFragments.push(entry.articlesHtml);
  }); // All inline related-article lists across this turn's text components
  // collapse into a single `<ul>` inside one `__text--sources` wrapper.
  // Computed once per render so the dedupe + DOMParser pass doesn't re-run
  // when only the parent (turn list) reshuffles.

  var mergedInlineArticlesHtml = mergeArticleListFragments(inlineArticleHtmlFragments);
  var hasRichSources = articleComponents.length > 0;
  var hasInlineArticleLists = mergedInlineArticlesHtml.length > 0;
  var hasSources = hasRichSources || hasInlineArticleLists;
  var hasRenderableInMain = turn.components.some(function (component, index) {
    if (component.type === 'article') return false;

    if (isTextComponent(component)) {
      var split = textHtmlByIndex.get(index);
      return Boolean(split === null || split === void 0 ? void 0 : split.mainHtml.replace(/<[^>]*>/g, '').trim());
    }

    return (0, _WidgetComponentRenderer.isSupportedComponent)(component);
  }); // Plain-text answer for the feedback `output` payload. Agent turns keep their
  // text in `components` (turn.content is empty), so flatten the rendered text
  // fragments and strip tags.

  var answerText = Array.from(textHtmlByIndex.values()).map(function (entry) {
    return entry.mainHtml;
  }).join(' ').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim(); // Mirror AI Answers' feedback tracking: figure out which thumb was clicked
  // from the event target and emit the analytics event. The shared Feedback
  // component itself persists the vote to `/hub-ai/feedback`.

  var handleFeedbackClick = function handleFeedbackClick(e) {
    var target = e.target;
    var button = target.closest('.feedback--button__like, .feedback--button__dislike');

    if (button !== null && button !== void 0 && button.classList.contains('feedback--button__like')) {
      onFeedbackVote === null || onFeedbackVote === void 0 ? void 0 : onFeedbackVote(1);
    } else if (button !== null && button !== void 0 && button.classList.contains('feedback--button__dislike')) {
      onFeedbackVote === null || onFeedbackVote === void 0 ? void 0 : onFeedbackVote(-1);
    }
  };

  return (0, _preact.h)("div", {
    className: "forethought-agent__turn forethought-agent__turn--agent"
  }, (0, _preact.h)("div", {
    className: "forethought-agent__turn-main"
  }, hasRenderableInMain ? turn.components.map(function (component, index) {
    if (component.type === 'article') return null;

    if (isTextComponent(component)) {
      var split = textHtmlByIndex.get(index);
      if (!split) return null;
      if (!split.mainHtml.replace(/<[^>]*>/g, '').trim()) return null;
      return (0, _preact.h)(_TextComponent.default, {
        key: "".concat(turn.id, "-").concat(index),
        component: component,
        htmlOverride: split.mainHtml
      });
    }

    return (0, _preact.h)(_WidgetComponentRenderer.default, {
      key: "".concat(turn.id, "-").concat(index),
      component: component,
      disabled: disabled,
      onButtonSelect: onButtonSelect,
      onFormSubmit: onFormSubmit,
      onSourceClick: onSourceClick
    });
  }) : (0, _preact.h)("div", {
    className: "forethought-agent__fallback"
  }, "The agent didn't return a displayable response. Try rephrasing your question."), (turn.reasoning !== undefined || hasRenderableInMain) && (0, _preact.h)("div", {
    className: "forethought-agent__turn-footer"
  }, turn.reasoning !== undefined && (0, _preact.h)(_ReasoningTrace.default, {
    components: turn.components,
    responseTimeMs: turn.responseTimeMs
  }), hasRenderableInMain && // eslint-disable-next-line jsx-a11y/no-static-element-interactions
  (0, _preact.h)("div", {
    className: "forethought-agent__turn-feedback",
    onClick: handleFeedbackClick
  }, (0, _preact.h)(_Feedback.Feedback // Reuse AI Answers' feature name so the vote persists through
  // the same `/hub-ai/feedback` allow-list entry — no backend
  // change needed. The forethought-specific analytics event
  // (handleFeedbackClick → trackForethoughtEvent) still keeps
  // the surface distinguishable.
  , {
    options: FEEDBACK_OPTIONS,
    featureName: "search-summary",
    input: userQuery !== null && userQuery !== void 0 ? userQuery : '',
    output: answerText,
    documentIds: articles.map(function (article) {
      return article.document_id;
    })
  }))), isLastAgentTurn && articles.length > 0 && (0, _preact.h)(_FollowUpPills.default, {
    articles: articles,
    disabled: disabled,
    onSelect: onFollowUpSelect
  })), hasSources && (0, _preact.h)("div", {
    className: "forethought-agent__turn-sources"
  }, isFirstAgentTurn && (0, _preact.h)("div", {
    className: "forethought-agent__turn-sources-header"
  }, "Related Articles"), articleComponents.map(function (component, index) {
    return (0, _preact.h)(_WidgetComponentRenderer.default, {
      key: "".concat(turn.id, "-src-").concat(index),
      component: component,
      disabled: disabled,
      onButtonSelect: onButtonSelect,
      onFormSubmit: onFormSubmit,
      onSourceClick: onSourceClick
    });
  }), hasInlineArticleLists && (0, _preact.h)("div", {
    className: "forethought-agent__text forethought-agent__text--sources",
    dangerouslySetInnerHTML: {
      __html: mergedInlineArticlesHtml
    }
  })));
};

var _default = AgentMessage;
exports.default = _default;